import React, { useState, useRef } from 'react';
import { Button } from './button';
import { Calendar } from 'lucide-react';
const DatePickerButton = ({
  selectedDate,
  // many callers still pass prop named `date` – support both
  date,
  onDateChange,
  label,
  placeholder = "Select date",
  className = ""
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const inputRef = useRef(null);
  const handleButtonClick = () => {
    if (inputRef.current) {
      inputRef.current.showPicker();
    }
  };
  const handleDateChange = e => {
    onDateChange(e.target.value);
  };
  const formatDisplayDate = dateString => {
    if (!dateString) return placeholder;
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };
  const currentDate = selectedDate ?? date ?? "";

  return <div className={className}>
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
        {label}
      </label>
      <div className="relative">
        <Button variant="outline" onClick={handleButtonClick} className="w-full justify-between text-left font-normal">
          <span className="text-gray-900 dark:text-white">
            {formatDisplayDate(currentDate)}
          </span>
          <Calendar className="h-4 w-4 text-gray-600 dark:text-gray-400" />
        </Button>
        
        <input ref={inputRef} type="date" value={currentDate} onChange={handleDateChange} max={new Date().toISOString().split('T')[0]} className="absolute inset-0 opacity-0 cursor-pointer" style={{
        zIndex: -1
      }} />
      </div>
    </div>;
};
export default DatePickerButton;